import React from 'react';
import { useNavigate } from 'react-router-dom';
import './styling/PrivacyPolicy.css';
import { NavigationBar } from '../Components/NavigationBar/NavigationBar';
import Footer from '../Components/Footer/Footer';

const PrivacyPolicy = () => {
    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/profile');
    };

    return (
        <div className="privacy-policy-container">
            <NavigationBar onBackClick={handleBack} title="Política de Privacidade" />
            <div className="privacy-policy-content">
                <h1>Política de Privacidade</h1>
                <div className="policy-section">
                    <h2>1. Introdução</h2>
                    <p>
                        Bem-vindo à Política de Privacidade do Reino Play. Este documento explica como coletamos,
                        usamos e protegemos suas informações pessoais.
                    </p>
                </div>

                <div className="policy-section">
                    <h2>2. Coleta de Dados</h2>
                    <p>
                        Coletamos informações que você nos fornece diretamente, como:
                    </p>
                    <ul>
                        <li>Nome e informações de contato</li>
                        <li>Informações de pagamento</li>
                        <li>Preferências de conteúdo</li>
                        <li>Histórico de visualização</li>
                    </ul>
                </div>

                <div className="policy-section">
                    <h2>3. Uso das Informações</h2>
                    <p>
                        Utilizamos suas informações para:
                    </p>
                    <ul>
                        <li>Fornecer e melhorar nossos serviços</li>
                        <li>Personalizar sua experiência</li>
                        <li>Processar pagamentos</li>
                        <li>Enviar atualizações e comunicações importantes</li>
                    </ul>
                </div>

                <div className="policy-section">
                    <h2>4. Proteção de Dados</h2>
                    <p>
                        Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações
                        contra acesso não autorizado, alteração, divulgação ou destruição.
                    </p>
                </div>

                <div className="policy-section">
                    <h2>5. Seus Direitos</h2>
                    <p>
                        Você tem direito a:
                    </p>
                    <ul>
                        <li>Acessar seus dados pessoais</li>
                        <li>Corrigir dados incorretos</li>
                        <li>Solicitar a exclusão de seus dados</li>
                        <li>Retirar seu consentimento</li>
                    </ul>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default PrivacyPolicy; 